<template>
  <div>
    <div v-if="user.id">
      <Header />
      <ResearcherMenu v-if="user.roles_all.some(e => e.researcher === true) || user.roles.includes('super-admin')" />
      <UniversityMenu v-if="user.roles.includes('university')" />
      <AwardedMenu v-if="user.roles.includes('awarded')" />
      <OndeuevMenu v-if="user.roles.includes('ondeuev')" />
      <EvaluatorMenu v-if="user.roles_all.some(e => e.evaluator === true) && !user.roles_all.some(e => e.researcher === true)" />
      <Menu v-if="user.roles.includes('super-admin')" />
    </div>
    <router-view
      @toggleModal="toggleModal"
    />
    <delete-modal
      :name="name"
      :url="modalUrl"
      :show="showModal == 'delete'"
      :required-fetch="requiredFetch"
      @closeModal="closeModal"
    />
    <reorganize-after-delete />
    <OTP />
    <AddFavorite />
    <ReportModal />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Header from '../../views/back/partials/Header.vue'
import Menu from '../../views/back/partials/Menu.vue'
import ResearcherMenu from '../../views/back/partials/ResearcherMenu.vue'
import UniversityMenu from '../../views/back/partials/UniversityMenu.vue'
import AwardedMenu from '../../views/back/partials/AwardedMenu.vue'
import EvaluatorMenu from '../../views/back/partials/EvaluatorMenu.vue'
import DeleteModal from '../../views/back/partials/modals/DeleteModal.vue'
import AccessModal from '../../views/back/partials/modals/AccessModal.vue'
import ReorganizeAfterDelete from '../../views/back/partials/modals/ReorganizeAfterDelete.vue'
import AddFavorite from '../../views/back/partials/offcanvas/AddFavorite.vue'
import OTP from '../../views/back/partials/modals/OTP.vue'
import ReportModal from '../../views/back/partials/modals/ReportModal.vue'
import OndeuevMenu from '../../views/back/partials/OndeuevMenu.vue'

// import core styles
require('@core/scss/core.scss')
require('@core/scss/vue/libs/vue-sweetalert.scss')

// import assets styles
require('@/assets/scss/components.scss')
require('@/assets/scss/style.scss')
require('@/assets/scss/vertical_menu.scss')
require('@/assets/scss/vue-select.scss')

export default {
  components: {
    Header,
    Menu,
    DeleteModal,
    AccessModal,
    ResearcherMenu,
    ReorganizeAfterDelete,
    OTP,
    EvaluatorMenu,
    AddFavorite,
    ReportModal,
    UniversityMenu,
    AwardedMenu,
    OndeuevMenu,
  },
  data() {
    return {
      showModal: false,
      modalUrl: '',
      name: '',
      requiredFetch: true,
      customMessage: '',
    }
  },
  computed: {
    ...mapGetters({
      user: 'auth/admin',
    }),
  },
  methods: {
    toggleModal(data) {
      this.showModal = data.type
      this.modalUrl = data.url
      this.name = data.name
      this.requiredFetch = data.requiredFetch
      this.customMessage = data.customMessage
    },
    closeModal() {
      this.showModal = false
    },
  },
}
</script>
